import { Box, Container } from "@mui/material"
import Progress from "../Progress"
import { withAuthenticationRequired, useAuth0 } from "@auth0/auth0-react";
import { Loading } from "../Loading";
import { useEffect } from "react";


const RequestBase = () => {
  // const { isAuthenticated, isLoading, getAccessTokenSilently, loginWithRedirect } = useAuth0()
  // useEffect(() => {
  //   const checkAuth = async () => {
  //     if (!isAuthenticated && !isLoading) {
  //       try {
  //         await getAccessTokenSilently()
  //       } catch (error) {
  //         loginWithRedirect()
  //       }
  //     }
  //   }
  //   checkAuth()
  // }, [isAuthenticated, isLoading, getAccessTokenSilently, loginWithRedirect])
  return (
    <Box>
      <Container maxWidth="xl">
        <Progress />
      </Container>
    </Box>
  )
}

// export default withAuthenticationRequired(RequestBase, { onRedirecting: () => (<Loading />) })
export default RequestBase